import { Routes } from "@angular/router";
import { LoginGuard } from "../../core/guards/login-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const configuracionRoutes: Routes = [
  {
    path: "inicio",
    loadComponent: () =>
      import("./components/dashboard/dashboard.component").then(
        (m) => m.DashboardComponent
      ),
    pathMatch: "full",
    canActivate: [LoginGuard],
  },
  {
    path: "ayuda",
    loadComponent: () =>
      import("./components/ayuda/ayuda.component").then(
        (m) => m.AyudaComponent
      ),
    pathMatch: "full",
    canActivate: [LoginGuard],
  },
  {
    path: "settings",
    loadComponent: () =>
      import("./components/configuraciones/configuraciones.component").then(
        (m) => m.ConfiguracionesComponent
      ),
    pathMatch: "full",
    canActivate: [LoginGuard],
  },
];
